const localIsoDate = (date) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

// The task order a project view opens on by default: the one in progress today (the latest-starting
// one if several overlap); otherwise the one that started most recently; otherwise the next to start.
// Ignores the automatic "Default" task order when the project has named ones, as the task order
// pickers do. Returns the task order object, or null when there are none.
export const pickCurrentTaskOrder = (taskOrders, today = new Date()) => {
  const list = (Array.isArray(taskOrders) ? taskOrders : []).filter((o) => Number.isInteger(Number(o?.id)));
  const named = list.filter((o) => !o?.isDefault && String(o?.name || '').trim());
  const candidates = named.length > 0 ? named : list;
  if (candidates.length === 0) return null;

  const todayIso = localIsoDate(today);
  const startOf = (o) => String(o?.startDate ?? o?.start_date ?? '').slice(0, 10);
  const endOf = (o) => String(o?.endDate ?? o?.end_date ?? '').slice(0, 10);
  const latestStartFirst = (a, b) => startOf(b).localeCompare(startOf(a)) || Number(b.id) - Number(a.id);

  const started = candidates.filter((o) => startOf(o) && startOf(o) <= todayIso).sort(latestStartFirst);
  const inProgress = started.find((o) => !endOf(o) || endOf(o) >= todayIso);
  if (inProgress) return inProgress;
  if (started.length > 0) return started[0];

  const upcoming = candidates
    .filter((o) => startOf(o))
    .sort((a, b) => startOf(a).localeCompare(startOf(b)) || Number(a.id) - Number(b.id));
  if (upcoming.length > 0) return upcoming[0];

  return [...candidates].sort((a, b) => Number(b.id) - Number(a.id))[0];
};
